import { useState } from "react";

import type { MetricsParameters } from "common/types";

import { STATS_TIMEFRAME_OPTIONS } from "../../pages/campaigns/constants";

const defaultTimeframeOption = STATS_TIMEFRAME_OPTIONS[2];

export default function useSelectedTimeframe(
  initialSelection: string | MetricsParameters,
) {
  // you can select a custom timeframe or the id of an existing timeframe option
  const [selectedTimeframe, setSelectedTimeframe] = useState<
    string | MetricsParameters
  >(() => {
    if (
      initialSelection &&
      (typeof initialSelection === "string" ||
        // we have to verify ths object is valid because we changed the object structure,
        // some users will have the old object saved in their local storage
        ("from" in initialSelection &&
          "to" in initialSelection &&
          "bucketSize" in initialSelection))
    ) {
      return initialSelection;
    }
    return defaultTimeframeOption.id;
  });

  let selectedTimeframeOption = STATS_TIMEFRAME_OPTIONS.find(
    ({ id }) => id === selectedTimeframe,
  );

  //custom timeframe
  if (typeof selectedTimeframe !== "string") {
    selectedTimeframeOption = {
      id: "custom",
      label: "Custom",
      getParameters: () => selectedTimeframe,
    };
  }

  return {
    selectedTimeframe,
    selectedTimeframeOption,
    setSelectedTimeframe,
  };
}
